import { useMemo } from "react";
import { ApiError, createApiClient, type ApiOptions } from "@am/shared";

const API_BASE = import.meta.env.VITE_API_BASE ?? "";

let currentKey: string | null = null;

export function setCurrentKey(key: string | null): void {
  currentKey = key;
}

const apiFn = createApiClient(API_BASE, () => {
  const headers: Record<string, string> = {};
  if (currentKey) headers["X-Platform-Admin-Key"] = currentKey;
  return headers;
});

export type ApiClient = <T = unknown>(path: string, opts?: ApiOptions) => Promise<T>;

export function useApiClient(): ApiClient {
  return useMemo(() => apiFn, []);
}

export { ApiError };
